"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTENTFUL_LOCALES = void 0;
const {
  LOCALES
} = require('@site/multibrand-locales');
const OMITTED_LOCALES = ['fr-CA', 'es-ES'];
const CONTENTFUL_LOCALES = exports.CONTENTFUL_LOCALES = LOCALES.filter(locale => !OMITTED_LOCALES.includes(locale));